import React from 'react';
import { Icon } from 'assets/Icon';
import heroPhone from "assets/images/hero-phone.png";
import './Hero.scss';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-left">
          <div className="brand-logo">
            <Icon name="logo3" className="brand-logo" />
          </div>
          <div className="hero-title">
            <h1>Fast, Reliable Connecticut Judicial Updates.</h1>
            <p>
              SGT Docket Rocket is the ultimate tool for Connecticut lawyers to stay ahead in their cases. 
              Designed with efficiency and convenience in mind, SGT Docket Rocket connects directly to the 
              Connecticut Judicial Website to provide quick updates on court filings, rulings, and schedule changes.
            </p>
          </div>
          <a href="https://apps.apple.com/us/app/sgt-docket-rocket/id6499451413" className="app-store-badge">
            <Icon name="app-store" className="app-store-icon" />
          </a>
        </div>
        <div className="hero-right">
          <div className="hero-gradient-box"></div>
          <div className="hero-phone">
            <img 
              src={heroPhone}
              alt="SGT Docket Rocket App" 
              className="phone-screen-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

